import { SupplierProductGetResponseChildType } from "@sellar-io/api-v2/types";
import { Alert } from "../../../../../../components/alert/Alert";
import { apiV2AssertError } from "../../../../../../hooks/api/v2/apiV2Request";
import { useProductUpdate } from "../../../../../../hooks/api/v2/product/useProductUpdate";

export const ProductCategoryItemStockTabContent = ({
  product,
  onClick,
}: {
  product: SupplierProductGetResponseChildType;
  onClick: () => void;
}) => {
  const productUpdateMutation = useProductUpdate(product.id);

  return (
    <>
      {productUpdateMutation.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(productUpdateMutation.error)?.response?.data
              .message ?? "Unknown error"
          }
        />
      )}

      <div
        onClick={onClick}
        className={
          "cursor-pointer overflow-x-auto rounded-lg border border-solid border-gray-200"
        }
      >
        <table className={"w-full table-auto border-spacing-0"}>
          <thead className={"text-left"}>
            <tr>
              {!!product.incomingStock && (
                <th className="border-r border-b border-gray-200 bg-zinc-50 p-2 text-xs">
                  {" "}
                  Incoming
                </th>
              )}

              <th className="border-r border-b border-gray-200 bg-zinc-50 p-2 text-xs">
                Total (on hand)
              </th>
              <th className="border-r border-b border-gray-200 bg-zinc-50 p-2 text-xs">
                Committed
              </th>
              <th className="border-b bg-zinc-50 p-2 text-xs">Available</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {!!product.incomingStock && (
                <td className="border-r border-gray-200 p-2 text-sm">
                  {product.incomingStock}
                </td>
              )}

              <td className="border-r border-gray-200 p-2 text-sm">
                {product.stock}
              </td>
              <td className="border-r border-gray-200 p-2 text-sm">
                {product.committedStock}
              </td>
              <td className="p-2 text-sm">{product.availableStock}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
